import { Inject, Injectable, DOCUMENT } from "@angular/core";

/**
 * Whitelist url service
 */
@Injectable()
export class FilesService {
  constructor(
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  /**
   * Download a file with a given content and name.
   * @param content Blob
   * @param name Name of the file
   */
  download(content: Blob, name: string): void {
    // We internally build a link to set the name of the file to download
    const link = this.document.createElement("a");
    link.setAttribute("href", URL.createObjectURL(content));
    link.setAttribute("download", name);
    link.click();
    URL.revokeObjectURL(link.href);
  }
}
